import React from "react";
import CommonButton from "./CommonButton";
import { useTranslationHook } from "../hooks/useTranslationHook";
import useThemeHook from "../hooks/useThemeHook";
import { THEME_COLORS } from "../themes/DarkLight";
import Text from "./ThemedText";
import { authWithPiNetwork } from "../utils/PiIntegration";
import arthereumProvider from "../../backend/ArthereumProvider";
import { useDispatch } from "react-redux";
import { PAGE_NAME } from "../../types";
import { actions } from "../redux";
import {
  LocalStorageController,
  LOCAL_STORAGE_DATA,
} from "../utils/LocalStorageController";
import { useNavigate } from "react-router-dom";
import weAreOnPiBrowser from "../utils/weAreOnPiBrowser";

export default function ContinueWithPiNetworkButton({
  action,
  setIsLoading,
  isLoading,
}: {
  action: "sign_in" | "sign_up";
  setIsLoading: Function;
  isLoading: boolean;
}) {
  const getTranslationText = useTranslationHook();
  const theme = useThemeHook();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const sign = async () => {
    if (action === "sign_up") {
      navigate(PAGE_NAME.ONBOARDING_SIGN_UP_WITH_PI);
      return;
    }
    if (isLoading) {
      return;
    }
    setIsLoading(true);
    const userPiData = await authWithPiNetwork();
    let user;
    try {
      if (action === "sign_in") {
        user = await arthereumProvider.signIn({
          path: "pi",
          piAccessToken: userPiData?.accessToken,
        });
        dispatch(actions.setActualUser(user));
        LocalStorageController.connect().storeData(
          LOCAL_STORAGE_DATA.SYSTEM_FULLY_INITIALIZED,
          "true"
        );
        LocalStorageController.connect().storeData(
          LOCAL_STORAGE_DATA.SIGN_IN_PATH,
          "pi"
        );
        navigate(PAGE_NAME.HOME, { replace: true });
      } else {
        navigate(PAGE_NAME.ONBOARDING_SIGN_UP_WITH_PI);
      }
    } catch (error) {
      console.log(error);
      alert(getTranslationText("error"));
    } finally {
      setIsLoading(false);
    }
  };
  return (
    <>
      <Text text="OR" style={{ textAlign: "center" }} />
      <CommonButton
        onClickHandle={sign}
        text={getTranslationText(
          action === "sign_in" ? "sign_in_with_pi" : "sign_up_with_pi",
          { method: "Pi Network" }
        )}
        backgroundColor={THEME_COLORS[theme].piPurple}
      />
    </>
  );
}
